module.exports = __webpack_public_path__ + "img/123.df387031.jpg";